import BaseRepository from "./base.repo";

class ReportRepository extends BaseRepository {
  async todayActivities(params: any = {}) {
    return this.client.get("/reports/today-activities", { params });
  }

  async dashboardCharts(params: any = {}) {
    return this.client.get("/reports/dashboard-charts", { params });
  }

  async dashboardReportList(params: any = {}) {
    return this.client.get("/reports/dashboard-report-list", { params });
  }

  async currentFoodOrders(params: any = {}) {
    return this.client.get("/reports/current-food-orders", { params });
  }

  async trends(params: any = {}) {
    const { data } = await this.client.get("/reports/trends", { params });
    return data;
  }

  async onlineRequests() {
    const { data } = await this.client.get("/reports/online-requests");
    return data?.data ?? { orders: [], bookings: [] };
  }

  async salesInsights(params: any = {}) {
    const { data } = await this.client.get("/reports/sales-insights", { params });
    return data;
  }

  async vatReport(params: any = {}) {
    const { data } = await this.client.get("/reports/vat", { params });
    return data;
  }

  async standardView(params: any = {}) {
    const { data } = await this.client.get("/reports/standard-view", { params });
    return data;
  }

  async fiscalYears() {
    const { data } = await this.client.get("/reports/fiscal-years");
    return data?.fiscal_years ?? [];
  }

  async returnRegisters(params: any = {}) {
    const { data } = await this.client.get("/reports/return-registers", { params });
    return data;
  }
}

export default ReportRepository;
